<template>
    <svg width="2475px" height="441px" viewBox="0 0 2475 441" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M88.8506 234.424H84.5312V302.891H88.8506V234.424Z" />
        <path d="M86.4844 219.186H86.9047V308.258H86.4844V219.186Z" />
        <path d="M108.222 257.176H103.902V289.467H108.222V257.176Z" />
        <path d="M105.852 243.875H106.272V290.688H105.852V243.875Z" />
        <path d="M98.5342 272.637H94.2148V312.205H98.5342V272.637Z" />
        <path d="M96.168 248.004H96.5883V327.029H96.168V248.004Z" />
        <path d="M79.167 275.98H74.8477V306.16H79.167V275.98Z" />
        <path d="M76.7969 257.191H77.2172V275.98H76.7969V257.191Z" />
        <path d="M76.7969 306.156H77.2172V317.465H76.7969V306.156Z" />
        <path d="M117.905 250.289H113.586V276.233H117.905V250.289Z" />
        <path d="M115.535 244.105H115.955V284.794H115.535V244.105Z" />
        <path d="M239.488 359.803H243.808V385.747H239.488V359.803Z" />
        <path d="M241.434 353.619H241.854V394.308H241.434V353.619Z" />
        <path d="M268.535 393.559H272.854V419.502H268.535V393.559Z" />
        <path d="M270.488 387.375H270.909V428.064H270.488V387.375Z" />
        <path d="M146.96 277.002H142.641V319.413H146.96V277.002Z" />
        <path d="M144.586 266.895H145.006V333.41H144.586V266.895Z" />
        <path d="M229.797 355.725H234.117V398.136H229.797V355.725Z" />
        <path d="M231.746 345.617H232.168V412.132H231.746V345.617Z" />
        <path d="M282.539 365.58H278.219V407.991H282.539V365.58Z" />
        <path d="M280.168 355.473H280.589V421.988H280.168V355.473Z" />
        <path d="M166.327 290.186H162.008V320.924H166.327V290.186Z" />
        <path d="M163.957 280.08H164.377V334.92H163.957V280.08Z" />
        <path d="M292.226 361.902H287.906V392.639H292.226V361.902Z" />
        <path d="M289.859 351.797H290.28V406.636H289.859V351.797Z" />
        <path d="M205.065 349.365H200.746V361.365H205.065V349.365Z" />
        <path d="M202.695 345.42H203.116V366.828H202.695V345.42Z" />
        <path d="M134.906 254.512H135.327V305.875H134.906V254.512Z" />
        <path d="M137.28 267.135H132.961V312.38H137.28V267.135Z" />
        <path d="M222.066 372.02H222.487V401.2H222.066V372.02Z" />
        <path d="M224.437 384.641H220.117V407.705H224.437V384.641Z" />
        <path d="M251.121 390.059H251.541V434.12H251.121V390.059Z" />
        <path d="M249.168 402.682H253.487V425.746H249.168V402.682Z" />
        <path d="M173.645 298.125H174.065V327.305H173.645V298.125Z" />
        <path d="M176.015 310.748H171.695V352.945H176.015V310.748Z" />
        <path d="M183.328 324.121H183.748V353.301H183.328V324.121Z" />
        <path d="M185.698 336.742H181.379V361.546H185.698V336.742Z" />
        <path d="M193.012 332.447H193.432V373.699H193.012V332.447Z" />
        <path d="M195.382 340.344H191.062V365.147H195.382V340.344Z" />
        <path d="M299.539 364.057H299.959V405.309H299.539V364.057Z" />
        <path d="M301.913 371.953H297.594V396.757H301.913V371.953Z" />
        <path d="M212.379 358.211H212.799V399.464H212.379V358.211Z" />
        <path d="M214.749 366.109H210.43V390.913H214.749V366.109Z" />
        <path d="M260.801 399.498H261.221V440.75H260.801V399.498Z" />
        <path d="M258.855 407.395H263.175V432.198H258.855V407.395Z" />
        <path d="M154.273 298.125H154.694V338.98H154.273V298.125Z" />
        <path d="M156.644 310.748H152.324V345.487H156.644V310.748Z" />
        <path d="M309.227 370.334H309.647V411.19H309.227V370.334Z" />
        <path d="M307.277 382.955H311.597V417.694H307.277V382.955Z" />
        <path d="M127.589 270.525H123.27V296.913H127.589V270.525Z" />
        <path d="M125.227 245.111H125.647V300.423H125.227V245.111Z" />
        <path d="M14.0029 220.264H9.68359V288.731H14.0029V220.264Z" />
        <path d="M11.6367 205.023H12.057V294.096H11.6367V205.023Z" />
        <path d="M33.374 243.014H29.0547V275.305H33.374V243.014Z" />
        <path d="M31.0039 229.713H31.4242V276.526H31.0039V229.713Z" />
        <path d="M23.6865 258.477H19.3672V298.045H23.6865V258.477Z" />
        <path d="M21.3164 233.844H21.7367V312.869H21.3164V233.844Z" />
        <path d="M4.31934 277.236H0V307.416H4.31934V277.236Z" />
        <path d="M1.94922 258.447H2.36951V277.236H1.94922V258.447Z" />
        <path d="M1.94922 291.996H2.36951V303.305H1.94922V291.996Z" />
        <path d="M43.0576 236.301H38.7383V262.245H43.0576V236.301Z" />
        <path d="M40.6875 230.119H41.1078V270.808H40.6875V230.119Z" />
        <path d="M72.1123 216.736H67.793V259.148H72.1123V216.736Z" />
        <path d="M69.7383 206.629H70.1586V273.144H69.7383V206.629Z" />
        <path d="M60.0547 194.246H60.475V245.609H60.0547V194.246Z" />
        <path d="M62.4248 206.869H58.1055V252.115H62.4248V206.869Z" />
        <path d="M52.7412 210.258H48.4219V236.645H52.7412V210.258Z" />
        <path d="M50.3711 184.846H50.7914V240.158H50.3711V184.846Z" />
        <path d="M331.698 305.889H327.379V374.356H331.698V305.889Z" />
        <path d="M329.328 290.648H329.748V379.721H329.328V290.648Z" />
        <path d="M351.065 328.639H346.746V360.93H351.065V328.639Z" />
        <path d="M348.699 315.338H349.12V362.151H348.699V315.338Z" />
        <path d="M341.378 344.1H337.059V383.668H341.378V344.1Z" />
        <path d="M339.012 319.467H339.432V398.492H339.012V319.467Z" />
        <path d="M322.011 347.445H317.691V377.625H322.011V347.445Z" />
        <path d="M319.641 328.654H320.061V347.443H319.641V328.654Z" />
        <path d="M319.641 377.621H320.061V388.93H319.641V377.621Z" />
        <path d="M360.749 321.752H356.43V347.696H360.749V321.752Z" />
        <path d="M358.379 315.568H358.799V356.257H358.379V315.568Z" />
        <path d="M513.379 177.68H517.698V203.623H513.379V177.68Z" />
        <path d="M515.332 171.496H515.752V212.185H515.332V171.496Z" />
        <path d="M389.804 267.035H385.484V309.446H389.804V267.035Z" />
        <path d="M387.434 256.928H387.854V323.443H387.434V256.928Z" />
        <path d="M525.387 149.701H521.066V192.112H525.387V149.701Z" />
        <path d="M523.016 139.594H523.437V206.109H523.016V139.594Z" />
        <path d="M409.175 280.221H404.855V310.959H409.175V280.221Z" />
        <path d="M406.809 270.113H407.229V324.953H406.809V270.113Z" />
        <path d="M535.069 146.025H530.75V176.762H535.069V146.025Z" />
        <path d="M532.703 135.92H533.123V190.759H532.703V135.92Z" />
        <path d="M377.754 277.26H378.174V328.623H377.754V277.26Z" />
        <path d="M380.124 289.883H375.805V335.128H380.124V289.883Z" />
        <path d="M542.383 148.178H542.803V189.43H542.383V148.178Z" />
        <path d="M544.761 156.076H540.441V180.88H544.761V156.076Z" />
        <path d="M441.688 226.02H437.368V251.963H441.688V226.02Z" />
        <path d="M439.738 219.836H439.318V260.524H439.738V219.836Z" />
        <path d="M451.371 221.941H447.051V264.353H451.371V221.941Z" />
        <path d="M449.422 211.834H449V278.349H449.422V211.834Z" />
        <path d="M476.106 215.582H480.426V227.581H476.106V215.582Z" />
        <path d="M478.473 211.637H478.052V233.045H478.473V211.637Z" />
        <path d="M459.109 238.236H458.689V267.417H459.109V238.236Z" />
        <path d="M456.735 250.857H461.055V273.922H456.735V250.857Z" />
        <path d="M430.051 256.275H429.63V300.337H430.051V256.275Z" />
        <path d="M432.004 268.898H427.685V291.963H432.004V268.898Z" />
        <path d="M507.527 171.92H507.107V201.1H507.527V171.92Z" />
        <path d="M505.157 184.541H509.477V226.738H505.157V184.541Z" />
        <path d="M497.84 203.012H497.42V232.192H497.84V203.012Z" />
        <path d="M495.474 202.959H499.793V227.763H495.474V202.959Z" />
        <path d="M488.16 198.664H487.74V239.916H488.16V198.664Z" />
        <path d="M485.79 206.561H490.109V231.364H485.79V206.561Z" />
        <path d="M468.793 224.428H468.373V265.681H468.793V224.428Z" />
        <path d="M466.423 232.324H470.742V257.128H466.423V232.324Z" />
        <path d="M420.367 265.715H419.947V306.967H420.367V265.715Z" />
        <path d="M422.316 273.611H417.997V298.415H422.316V273.611Z" />
        <path d="M397.117 288.16H397.537V329.015H397.117V288.16Z" />
        <path d="M399.487 300.781H395.168V335.52H399.487V300.781Z" />
        <path d="M552.07 154.455H552.491V195.311H552.07V154.455Z" />
        <path d="M550.121 167.078H554.44V201.817H550.121V167.078Z" />
        <path d="M370.433 293.273H366.113V319.661H370.433V293.273Z" />
        <path d="M368.07 267.859H368.491V323.172H368.07V267.859Z" />
        <path d="M573.276 97.707H568.957V166.175H573.276V97.707Z" />
        <path d="M570.906 82.4668H571.327V171.539H570.906V82.4668Z" />
        <path d="M592.644 120.457H588.324V152.749H592.644V120.457Z" />
        <path d="M590.277 107.156H590.698V153.969H590.277V107.156Z" />
        <path d="M582.956 135.92H578.637V175.489H582.956V135.92Z" />
        <path d="M580.59 111.287H581.01V190.312H580.59V111.287Z" />
        <path d="M563.589 139.264H559.27V169.443H563.589V139.264Z" />
        <path d="M561.219 120.475H561.639V139.263H561.219V120.475Z" />
        <path d="M561.219 169.439H561.639V180.748H561.219V169.439Z" />
        <path d="M602.327 113.57H598.008V139.514H602.327V113.57Z" />
        <path d="M599.957 107.389H600.377V148.077H599.957V107.389Z" />
        <path d="M723.906 134.078H728.226V160.022H723.906V134.078Z" />
        <path d="M725.855 127.895H726.276V168.583H725.855V127.895Z" />
        <path d="M752.961 203.887H757.28V229.83H752.961V203.887Z" />
        <path d="M754.91 197.703H755.33V238.392H754.91V197.703Z" />
        <path d="M631.382 58.8555H627.062V101.267H631.382V58.8555Z" />
        <path d="M629.012 48.748H629.432V115.263H629.012V48.748Z" />
        <path d="M714.223 130H718.543V172.411H714.223V130Z" />
        <path d="M716.172 119.893H716.593V186.408H716.172V119.893Z" />
        <path d="M766.965 217.814H762.645V260.226H766.965V217.814Z" />
        <path d="M764.594 207.709H765.015V274.224H764.594V207.709Z" />
        <path d="M650.753 72.0391H646.434V102.777H650.753V72.0391Z" />
        <path d="M648.387 61.9336H648.807V116.773H648.387V61.9336Z" />
        <path d="M776.647 214.139H772.328V244.876H776.647V214.139Z" />
        <path d="M774.281 204.033H774.702V258.873H774.281V204.033Z" />
        <path d="M689.487 123.641H685.168V135.64H689.487V123.641Z" />
        <path d="M687.121 119.695H687.541V141.104H687.121V119.695Z" />
        <path d="M619.332 69.0801H619.752V120.443H619.332V69.0801Z" />
        <path d="M621.702 81.7012H617.383V126.947H621.702V81.7012Z" />
        <path d="M706.484 146.295H706.905V175.475H706.484V146.295Z" />
        <path d="M708.858 158.916H704.539V181.98H708.858V158.916Z" />
        <path d="M735.543 164.334H735.963V208.395H735.543V164.334Z" />
        <path d="M733.59 176.957H737.909V200.021H733.59V176.957Z" />
        <path d="M658.066 79.9785H658.487V109.159H658.066V79.9785Z" />
        <path d="M660.437 92.5996H656.117V134.797H660.437V92.5996Z" />
        <path d="M667.75 111.07H668.17V140.25H667.75V111.07Z" />
        <path d="M670.12 111.018H665.801V135.821H670.12V111.018Z" />
        <path d="M677.434 106.723H677.854V147.975H677.434V106.723Z" />
        <path d="M679.804 114.619H675.484V139.423H679.804V114.619Z" />
        <path d="M783.961 216.291H784.381V257.543H783.961V216.291Z" />
        <path d="M786.339 224.189H782.02V248.993H786.339V224.189Z" />
        <path d="M696.801 132.486H697.221V173.74H696.801V132.486Z" />
        <path d="M699.171 140.385H694.852V165.188H699.171V140.385Z" />
        <path d="M745.227 173.773H745.647V215.026H745.227V173.773Z" />
        <path d="M743.281 181.67H747.601V206.474H743.281V181.67Z" />
        <path d="M638.695 79.9785H639.116V120.833H638.695V79.9785Z" />
        <path d="M641.065 92.5996H636.746V127.338H641.065V92.5996Z" />
        <path d="M793.648 222.568H794.069V263.424H793.648V222.568Z" />
        <path d="M791.699 235.191H796.019V269.93H791.699V235.191Z" />
        <path d="M612.011 85.0918H607.691V111.479H612.011V85.0918Z" />
        <path d="M609.648 59.6777H610.069V114.99H609.648V59.6777Z" />
        <path d="M889.847 170.08H885.527V238.548H889.847V170.08Z" />
        <path d="M887.48 154.84H887.901V243.912H887.48V154.84Z" />
        <path d="M909.218 192.83H904.898V225.122H909.218V192.83Z" />
        <path d="M906.848 179.529H907.268V226.342H906.848V179.529Z" />
        <path d="M899.538 208.293H895.219V247.862H899.538V208.293Z" />
        <path d="M897.164 183.658H897.584V262.683H897.164V183.658Z" />
        <path d="M880.163 211.637H875.844V241.816H880.163V211.637Z" />
        <path d="M877.793 192.848H878.213V211.636H877.793V192.848Z" />
        <path d="M877.793 241.812H878.213V253.121H877.793V241.812Z" />
        <path d="M918.901 227.654H914.582V253.598H918.901V227.654Z" />
        <path d="M916.531 221.473H916.952V262.161H916.531V221.473Z" />
        <path d="M1040.48 295.457H1044.8V321.401H1040.48V295.457Z" />
        <path d="M1042.43 289.275H1042.85V329.964H1042.43V289.275Z" />
        <path d="M1069.53 329.213H1073.85V355.156H1069.53V329.213Z" />
        <path d="M1071.48 323.029H1071.9V363.719H1071.48V323.029Z" />
        <path d="M947.956 212.656H943.637V255.068H947.956V212.656Z" />
        <path d="M945.582 202.549H946.002V269.064H945.582V202.549Z" />
        <path d="M1030.79 291.379H1035.11V333.79H1030.79V291.379Z" />
        <path d="M1032.74 281.271H1033.16V347.787H1032.74V281.271Z" />
        <path d="M1083.54 301.234H1079.21V343.646H1083.54V301.234Z" />
        <path d="M1081.16 291.127H1081.59V357.642H1081.16V291.127Z" />
        <path d="M967.323 225.842H963.004V256.58H967.323V225.842Z" />
        <path d="M964.953 215.734H965.373V270.574H964.953V215.734Z" />
        <path d="M1093.22 297.559H1088.9V328.296H1093.22V297.559Z" />
        <path d="M1090.86 287.451H1091.28V342.291H1090.86V287.451Z" />
        <path d="M1006.06 285.02H1001.74V297.019H1006.06V285.02Z" />
        <path d="M1003.69 281.074H1004.11V302.483H1003.69V281.074Z" />
        <path d="M935.902 190.168H936.323V241.531H935.902V190.168Z" />
        <path d="M938.276 202.789H933.957V248.035H938.276V202.789Z" />
        <path d="M1023.06 307.674H1023.48V336.854H1023.06V307.674Z" />
        <path d="M1025.43 320.297H1021.11V343.361H1025.43V320.297Z" />
        <path d="M1052.12 325.715H1052.54V369.776H1052.12V325.715Z" />
        <path d="M1050.16 338.336H1054.48V361.4H1050.16V338.336Z" />
        <path d="M974.641 233.781H975.061V262.962H974.641V233.781Z" />
        <path d="M977.011 246.402H972.691V288.6H977.011V246.402Z" />
        <path d="M984.324 259.775H984.745V288.955H984.324V259.775Z" />
        <path d="M986.694 272.396H982.375V297.2H986.694V272.396Z" />
        <path d="M994.008 268.102H994.428V309.354H994.008V268.102Z" />
        <path d="M996.378 275.998H992.059V300.802H996.378V275.998Z" />
        <path d="M1100.54 299.711H1100.96V340.963H1100.54V299.711Z" />
        <path d="M1102.91 307.607H1098.59V332.411H1102.91V307.607Z" />
        <path d="M1013.38 293.867H1013.8V335.12H1013.38V293.867Z" />
        <path d="M1015.75 301.764H1011.43V326.567H1015.75V301.764Z" />
        <path d="M1061.8 335.152H1062.22V376.405H1061.8V335.152Z" />
        <path d="M1059.85 343.051H1064.17V367.855H1059.85V343.051Z" />
        <path d="M955.27 233.781H955.69V274.636H955.27V233.781Z" />
        <path d="M957.64 246.402H953.32V281.141H957.64V246.402Z" />
        <path d="M1110.22 305.988H1110.64V346.844H1110.22V305.988Z" />
        <path d="M1108.27 318.611H1112.59V353.35H1108.27V318.611Z" />
        <path d="M928.585 206.18H924.266V232.567H928.585V206.18Z" />
        <path d="M926.223 180.766H926.643V236.078H926.223V180.766Z" />
        <path d="M815.003 204.092H810.684V272.559H815.003V204.092Z" />
        <path d="M812.637 188.852H813.057V277.924H812.637V188.852Z" />
        <path d="M834.374 226.842H830.055V259.133H834.374V226.842Z" />
        <path d="M832.004 213.541H832.424V260.354H832.004V213.541Z" />
        <path d="M824.687 242.305H820.367V281.873H824.687V242.305Z" />
        <path d="M822.316 217.67H822.737V296.695H822.316V217.67Z" />
        <path d="M805.319 261.064H801V291.244H805.319V261.064Z" />
        <path d="M802.949 242.275H803.37V261.064H802.949V242.275Z" />
        <path d="M802.949 275.824H803.37V287.133H802.949V275.824Z" />
        <path d="M844.058 220.129H839.738V246.073H844.058V220.129Z" />
        <path d="M841.688 213.945H842.108V254.634H841.688V213.945Z" />
        <path d="M873.112 200.562H868.793V242.974H873.112V200.562Z" />
        <path d="M870.738 190.457H871.159V256.972H870.738V190.457Z" />
        <path d="M861.055 178.074H861.475V229.437H861.055V178.074Z" />
        <path d="M863.425 190.697H859.105V235.943H863.425V190.697Z" />
        <path d="M853.741 194.086H849.422V220.473H853.741V194.086Z" />
        <path d="M851.371 168.674H851.791V223.986H851.371V168.674Z" />
        <path d="M1132.71 241.543H1128.39V310.01H1132.71V241.543Z" />
        <path d="M1130.34 226.303H1130.76V315.375H1130.34V226.303Z" />
        <path d="M1152.07 264.293H1147.75V296.585H1152.07V264.293Z" />
        <path d="M1149.71 250.992H1150.13V297.805H1149.71V250.992Z" />
        <path d="M1142.39 279.756H1138.07V319.325H1142.39V279.756Z" />
        <path d="M1140.02 255.121H1140.44V334.146H1140.02V255.121Z" />
        <path d="M1123.02 283.1H1118.7V313.279H1123.02V283.1Z" />
        <path d="M1120.65 264.311H1121.07V283.099H1120.65V264.311Z" />
        <path d="M1120.65 313.275H1121.07V324.584H1120.65V313.275Z" />
        <path d="M1161.76 257.406H1157.44V283.35H1161.76V257.406Z" />
        <path d="M1159.39 251.225H1159.81V291.913H1159.39V251.225Z" />
        <path d="M1314.39 113.336H1318.71V139.279H1314.39V113.336Z" />
        <path d="M1316.34 107.152H1316.76V147.842H1316.34V107.152Z" />
        <path d="M1190.81 202.691H1186.49V245.103H1190.81V202.691Z" />
        <path d="M1188.44 192.584H1188.86V259.099H1188.44V192.584Z" />
        <path d="M1326.39 85.3574H1322.07V127.769H1326.39V85.3574Z" />
        <path d="M1324.02 75.25H1324.44V141.765H1324.02V75.25Z" />
        <path d="M1210.18 215.875H1205.86V246.613H1210.18V215.875Z" />
        <path d="M1207.82 205.77H1208.24V260.609H1207.82V205.77Z" />
        <path d="M1336.08 81.6797H1331.76V112.417H1336.08V81.6797Z" />
        <path d="M1333.71 71.5742H1334.13V126.414H1333.71V71.5742Z" />
        <path d="M1178.76 212.916H1179.18V264.279H1178.76V212.916Z" />
        <path d="M1181.13 225.537H1176.81V270.783H1181.13V225.537Z" />
        <path d="M1343.39 83.832H1343.81V125.084H1343.39V83.832Z" />
        <path d="M1345.77 91.7305H1341.45V116.534H1345.77V91.7305Z" />
        <path d="M1242.7 161.674H1238.38V187.618H1242.7V161.674Z" />
        <path d="M1240.75 155.49H1240.33V196.179H1240.75V155.49Z" />
        <path d="M1252.38 157.596H1248.06V200.007H1252.38V157.596Z" />
        <path d="M1250.43 147.488H1250.01V214.003H1250.43V147.488Z" />
        <path d="M1277.11 151.236H1281.43V163.236H1277.11V151.236Z" />
        <path d="M1279.48 147.291H1279.06V168.699H1279.48V147.291Z" />
        <path d="M1260.12 173.891H1259.7V203.071H1260.12V173.891Z" />
        <path d="M1257.74 186.512H1262.06V209.576H1257.74V186.512Z" />
        <path d="M1231.06 191.93H1230.64V235.991H1231.06V191.93Z" />
        <path d="M1233.01 204.553H1228.69V227.617H1233.01V204.553Z" />
        <path d="M1308.54 107.574H1308.11V136.755H1308.54V107.574Z" />
        <path d="M1306.17 120.195H1310.48V162.393H1306.17V120.195Z" />
        <path d="M1298.85 138.666H1298.43V167.846H1298.85V138.666Z" />
        <path d="M1296.48 138.613H1300.8V163.417H1296.48V138.613Z" />
        <path d="M1289.17 134.318H1288.75V175.57H1289.17V134.318Z" />
        <path d="M1286.8 142.215H1291.12V167.019H1286.8V142.215Z" />
        <path d="M1269.8 160.082H1269.38V201.335H1269.8V160.082Z" />
        <path d="M1267.43 167.98H1271.75V192.784H1267.43V167.98Z" />
        <path d="M1221.38 201.369H1220.95V242.621H1221.38V201.369Z" />
        <path d="M1223.32 209.266H1219V234.07H1223.32V209.266Z" />
        <path d="M1198.12 223.814H1198.55V264.669H1198.12V223.814Z" />
        <path d="M1200.5 236.436H1196.18V271.174H1200.5V236.436Z" />
        <path d="M1353.08 90.1094H1353.5V130.965H1353.08V90.1094Z" />
        <path d="M1351.13 102.732H1355.45V137.471H1351.13V102.732Z" />
        <path d="M1171.44 228.928H1167.12V255.315H1171.44V228.928Z" />
        <path d="M1169.08 203.514H1169.5V258.826H1169.08V203.514Z" />
        <path d="M1374.28 49.5332H1369.96V118.001H1374.28V49.5332Z" />
        <path d="M1371.91 34.2949H1372.33V123.367H1371.91V34.2949Z" />
        <path d="M1393.64 72.2852H1389.32V104.577H1393.64V72.2852Z" />
        <path d="M1391.28 58.9844H1391.7V105.797H1391.28V58.9844Z" />
        <path d="M1383.96 87.7461H1379.64V127.315H1383.96V87.7461Z" />
        <path d="M1381.59 63.1133H1382.01V142.138H1381.59V63.1133Z" />
        <path d="M1364.59 91.0898H1360.27V121.269H1364.59V91.0898Z" />
        <path d="M1362.22 72.3008H1362.64V91.0892H1362.22V72.3008Z" />
        <path d="M1362.22 121.266H1362.64V132.574H1362.22V121.266Z" />
        <path d="M1403.33 65.3984H1399.01V91.3425H1403.33V65.3984Z" />
        <path d="M1400.96 59.2148H1401.38V99.9033H1400.96V59.2148Z" />
        <path d="M1524.91 85.9043H1529.23V111.848H1524.91V85.9043Z" />
        <path d="M1526.86 79.7227H1527.28V120.411H1526.86V79.7227Z" />
        <path d="M1553.96 155.715H1558.28V181.658H1553.96V155.715Z" />
        <path d="M1555.91 149.531H1556.33V190.22H1555.91V149.531Z" />
        <path d="M1432.38 10.6816H1428.06V53.0929H1432.38V10.6816Z" />
        <path d="M1430.01 0.574219H1430.43V67.0893H1430.01V0.574219Z" />
        <path d="M1515.22 81.8262H1519.54V124.238H1515.22V81.8262Z" />
        <path d="M1517.17 71.7188H1517.59V138.234H1517.17V71.7188Z" />
        <path d="M1567.96 169.643H1563.64V212.054H1567.96V169.643Z" />
        <path d="M1565.59 159.535H1566.02V226.05H1565.59V159.535Z" />
        <path d="M1451.75 23.8652H1447.43V54.6032H1451.75V23.8652Z" />
        <path d="M1449.39 13.7598H1449.81V68.5993H1449.39V13.7598Z" />
        <path d="M1577.65 165.965H1573.33V196.702H1577.65V165.965Z" />
        <path d="M1575.28 155.859H1575.7V210.699H1575.28V155.859Z" />
        <path d="M1490.49 75.4668H1486.17V87.4662H1490.49V75.4668Z" />
        <path d="M1488.12 71.5215H1488.54V92.9298H1488.12V71.5215Z" />
        <path d="M1420.33 20.9062H1420.75V72.2691H1420.33V20.9062Z" />
        <path d="M1422.7 33.5293H1418.38V78.7748H1422.7V33.5293Z" />
        <path d="M1507.48 98.1211H1507.9V127.302H1507.48V98.1211Z" />
        <path d="M1509.86 110.744H1505.54V133.808H1509.86V110.744Z" />
        <path d="M1536.54 116.162H1536.96V160.223H1536.54V116.162Z" />
        <path d="M1534.59 128.783H1538.91V151.848H1534.59V128.783Z" />
        <path d="M1459.07 31.8047H1459.49V60.9852H1459.07V31.8047Z" />
        <path d="M1461.44 44.4277H1457.12V86.6251H1461.44V44.4277Z" />
        <path d="M1468.75 62.8965H1469.17V92.0765H1468.75V62.8965Z" />
        <path d="M1471.12 62.8438H1466.8V87.6475H1471.12V62.8438Z" />
        <path d="M1478.43 58.5488H1478.85V99.8008H1478.43V58.5488Z" />
        <path d="M1480.8 66.4473H1476.48V91.251H1480.8V66.4473Z" />
        <path d="M1584.96 168.117H1585.38V209.37H1584.96V168.117Z" />
        <path d="M1587.34 176.016H1583.02V200.819H1587.34V176.016Z" />
        <path d="M1497.8 84.3145H1498.22V125.568H1497.8V84.3145Z" />
        <path d="M1500.17 92.2109H1495.85V117.015H1500.17V92.2109Z" />
        <path d="M1546.23 125.6H1546.65V166.852H1546.23V125.6Z" />
        <path d="M1544.28 133.498H1548.6V158.302H1544.28V133.498Z" />
        <path d="M1439.7 31.8047H1440.12V72.6595H1439.7V31.8047Z" />
        <path d="M1442.07 44.4277H1437.75V79.1662H1442.07V44.4277Z" />
        <path d="M1594.65 174.395H1595.07V215.25H1594.65V174.395Z" />
        <path d="M1592.7 187.018H1597.02V221.756H1592.7V187.018Z" />
        <path d="M1413.01 36.918H1408.69V63.3055H1413.01V36.918Z" />
        <path d="M1410.65 11.5059H1411.07V66.818H1410.65V11.5059Z" />
        <path d="M1689.87 234.426H1685.55V302.893H1689.87V234.426Z" />
        <path d="M1687.5 219.186H1687.92V308.258H1687.5V219.186Z" />
        <path d="M1709.24 257.176H1704.92V289.467H1709.24V257.176Z" />
        <path d="M1706.87 243.875H1707.29V290.688H1706.87V243.875Z" />
        <path d="M1699.55 272.637H1695.23V312.205H1699.55V272.637Z" />
        <path d="M1697.19 248.004H1697.61V327.029H1697.19V248.004Z" />
        <path d="M1680.19 275.982H1675.87V306.162H1680.19V275.982Z" />
        <path d="M1677.82 257.191H1678.24V275.98H1677.82V257.191Z" />
        <path d="M1677.82 306.158H1678.24V317.467H1677.82V306.158Z" />
        <path d="M1718.92 250.289H1714.61V276.233H1718.92V250.289Z" />
        <path d="M1716.55 244.107H1716.97V284.796H1716.55V244.107Z" />
        <path d="M1840.51 359.803H1844.83V385.747H1840.51V359.803Z" />
        <path d="M1842.45 353.621H1842.87V394.31H1842.45V353.621Z" />
        <path d="M1869.55 393.559H1873.87V419.502H1869.55V393.559Z" />
        <path d="M1871.51 387.375H1871.93V428.064H1871.51V387.375Z" />
        <path d="M1747.98 277.002H1743.66V319.413H1747.98V277.002Z" />
        <path d="M1745.61 266.895H1746.03V333.41H1745.61V266.895Z" />
        <path d="M1830.82 355.725H1835.14V398.136H1830.82V355.725Z" />
        <path d="M1832.77 345.617H1833.19V412.132H1832.77V345.617Z" />
        <path d="M1883.56 365.58H1879.24V407.991H1883.56V365.58Z" />
        <path d="M1881.19 355.473H1881.61V421.988H1881.19V355.473Z" />
        <path d="M1767.35 290.188H1763.03V320.925H1767.35V290.188Z" />
        <path d="M1764.98 280.08H1765.4V334.92H1764.98V280.08Z" />
        <path d="M1893.25 361.904H1888.93V392.641H1893.25V361.904Z" />
        <path d="M1890.88 351.797H1891.3V406.636H1890.88V351.797Z" />
        <path d="M1806.08 349.365H1801.77V361.365H1806.08V349.365Z" />
        <path d="M1803.71 345.42H1804.14V366.828H1803.71V345.42Z" />
        <path d="M1735.93 254.512H1736.35V305.875H1735.93V254.512Z" />
        <path d="M1738.3 267.135H1733.98V312.38H1738.3V267.135Z" />
        <path d="M1823.09 372.02H1823.51V401.2H1823.09V372.02Z" />
        <path d="M1825.46 384.643H1821.14V407.707H1825.46V384.643Z" />
        <path d="M1852.14 390.061H1852.56V434.122H1852.14V390.061Z" />
        <path d="M1850.19 402.682H1854.51V425.746H1850.19V402.682Z" />
        <path d="M1774.66 298.127H1775.08V327.307H1774.66V298.127Z" />
        <path d="M1777.03 310.748H1772.71V352.945H1777.03V310.748Z" />
        <path d="M1784.35 324.121H1784.77V353.301H1784.35V324.121Z" />
        <path d="M1786.72 336.742H1782.4V361.546H1786.72V336.742Z" />
        <path d="M1794.03 332.447H1794.45V373.699H1794.03V332.447Z" />
        <path d="M1796.4 340.344H1792.08V365.147H1796.4V340.344Z" />
        <path d="M1900.56 364.057H1900.98V405.309H1900.56V364.057Z" />
        <path d="M1902.93 371.953H1898.61V396.757H1902.93V371.953Z" />
        <path d="M1813.4 358.211H1813.82V399.464H1813.4V358.211Z" />
        <path d="M1815.77 366.109H1811.45V390.913H1815.77V366.109Z" />
        <path d="M1861.82 399.498H1862.24V440.75H1861.82V399.498Z" />
        <path d="M1859.88 407.395H1864.19V432.198H1859.88V407.395Z" />
        <path d="M1755.29 298.127H1755.71V338.982H1755.29V298.127Z" />
        <path d="M1757.66 310.748H1753.34V345.487H1757.66V310.748Z" />
        <path d="M1910.25 370.334H1910.67V411.19H1910.25V370.334Z" />
        <path d="M1908.3 382.957H1912.62V417.696H1908.3V382.957Z" />
        <path d="M1728.61 270.525H1724.29V296.913H1728.61V270.525Z" />
        <path d="M1726.25 245.111H1726.67V300.423H1726.25V245.111Z" />
        <path d="M1615.02 220.264H1610.7V288.731H1615.02V220.264Z" />
        <path d="M1612.66 205.025H1613.08V294.098H1612.66V205.025Z" />
        <path d="M1634.39 243.016H1630.07V275.307H1634.39V243.016Z" />
        <path d="M1632.02 229.715H1632.44V276.528H1632.02V229.715Z" />
        <path d="M1624.71 258.477H1620.39V298.045H1624.71V258.477Z" />
        <path d="M1622.34 233.844H1622.76V312.869H1622.34V233.844Z" />
        <path d="M1605.34 277.236H1601.02V307.416H1605.34V277.236Z" />
        <path d="M1602.97 258.447H1603.39V277.236H1602.97V258.447Z" />
        <path d="M1602.97 291.998H1603.39V303.307H1602.97V291.998Z" />
        <path d="M1644.08 236.301H1639.76V262.245H1644.08V236.301Z" />
        <path d="M1641.71 230.119H1642.13V270.808H1641.71V230.119Z" />
        <path d="M1673.13 216.736H1668.81V259.148H1673.13V216.736Z" />
        <path d="M1670.76 206.629H1671.18V273.144H1670.76V206.629Z" />
        <path d="M1661.07 194.246H1661.49V245.609H1661.07V194.246Z" />
        <path d="M1663.44 206.869H1659.12V252.115H1663.44V206.869Z" />
        <path d="M1653.76 210.26H1649.44V236.647H1653.76V210.26Z" />
        <path d="M1651.39 184.846H1651.81V240.158H1651.39V184.846Z" />
        <path d="M1932.72 305.889H1928.4V374.356H1932.72V305.889Z" />
        <path d="M1930.35 290.648H1930.77V379.721H1930.35V290.648Z" />
        <path d="M1952.08 328.639H1947.77V360.93H1952.08V328.639Z" />
        <path d="M1949.72 315.338H1950.14V362.151H1949.72V315.338Z" />
        <path d="M1942.4 344.102H1938.08V383.67H1942.4V344.102Z" />
        <path d="M1940.03 319.469H1940.45V398.494H1940.03V319.469Z" />
        <path d="M1923.03 347.445H1918.71V377.625H1923.03V347.445Z" />
        <path d="M1920.66 328.656H1921.08V347.445H1920.66V328.656Z" />
        <path d="M1920.66 377.621H1921.08V388.93H1920.66V377.621Z" />
        <path d="M1961.77 321.752H1957.45V347.696H1961.77V321.752Z" />
        <path d="M1959.4 315.57H1959.82V356.259H1959.4V315.57Z" />
        <path d="M2114.4 177.682H2118.72V203.625H2114.4V177.682Z" />
        <path d="M2116.35 171.498H2116.77V212.187H2116.35V171.498Z" />
        <path d="M1990.82 267.035H1986.5V309.446H1990.82V267.035Z" />
        <path d="M1988.45 256.93H1988.87V323.445H1988.45V256.93Z" />
        <path d="M2126.41 149.703H2122.09V192.114H2126.41V149.703Z" />
        <path d="M2124.04 139.596H2124.46V206.111H2124.04V139.596Z" />
        <path d="M2010.19 280.221H2005.88V310.959H2010.19V280.221Z" />
        <path d="M2007.83 270.113H2008.25V324.953H2007.83V270.113Z" />
        <path d="M2136.09 146.025H2131.77V176.762H2136.09V146.025Z" />
        <path d="M2133.72 135.92H2134.14V190.759H2133.72V135.92Z" />
        <path d="M1978.77 277.262H1979.19V328.625H1978.77V277.262Z" />
        <path d="M1981.14 289.883H1976.82V335.128H1981.14V289.883Z" />
        <path d="M2143.4 148.18H2143.82V189.432H2143.4V148.18Z" />
        <path d="M2145.78 156.076H2141.46V180.88H2145.78V156.076Z" />
        <path d="M2042.71 226.02H2038.39V251.963H2042.71V226.02Z" />
        <path d="M2040.76 219.836H2040.34V260.524H2040.76V219.836Z" />
        <path d="M2052.39 221.941H2048.07V264.353H2052.39V221.941Z" />
        <path d="M2050.44 211.834H2050.02V278.349H2050.44V211.834Z" />
        <path d="M2077.13 215.582H2081.45V227.581H2077.13V215.582Z" />
        <path d="M2079.49 211.637H2079.07V233.045H2079.49V211.637Z" />
        <path d="M2060.13 238.236H2059.71V267.417H2060.13V238.236Z" />
        <path d="M2057.75 250.857H2062.07V273.922H2057.75V250.857Z" />
        <path d="M2031.07 256.275H2030.65V300.337H2031.07V256.275Z" />
        <path d="M2033.02 268.898H2028.7V291.963H2033.02V268.898Z" />
        <path d="M2108.55 171.92H2108.13V201.1H2108.55V171.92Z" />
        <path d="M2106.18 184.541H2110.5V226.738H2106.18V184.541Z" />
        <path d="M2098.86 203.012H2098.44V232.192H2098.86V203.012Z" />
        <path d="M2096.49 202.959H2100.81V227.763H2096.49V202.959Z" />
        <path d="M2089.18 198.664H2088.76V239.916H2089.18V198.664Z" />
        <path d="M2086.81 206.561H2091.13V231.364H2086.81V206.561Z" />
        <path d="M2069.81 224.428H2069.39V265.681H2069.81V224.428Z" />
        <path d="M2067.44 232.324H2071.76V257.128H2067.44V232.324Z" />
        <path d="M2021.39 265.715H2020.97V306.967H2021.39V265.715Z" />
        <path d="M2023.34 273.611H2019.02V298.415H2023.34V273.611Z" />
        <path d="M1998.14 288.16H1998.56V329.015H1998.14V288.16Z" />
        <path d="M2000.51 300.781H1996.19V335.52H2000.51V300.781Z" />
        <path d="M2153.09 154.455H2153.51V195.311H2153.09V154.455Z" />
        <path d="M2151.14 167.078H2155.46V201.817H2151.14V167.078Z" />
        <path d="M1971.45 293.273H1967.13V319.661H1971.45V293.273Z" />
        <path d="M1969.09 267.859H1969.51V323.172H1969.09V267.859Z" />
        <path d="M2174.3 97.707H2169.98V166.175H2174.3V97.707Z" />
        <path d="M2171.93 82.4688H2172.35V171.541H2171.93V82.4688Z" />
        <path d="M2193.66 120.459H2189.34V152.751H2193.66V120.459Z" />
        <path d="M2191.3 107.158H2191.72V153.971H2191.3V107.158Z" />
        <path d="M2183.98 135.92H2179.66V175.489H2183.98V135.92Z" />
        <path d="M2181.61 111.287H2182.03V190.312H2181.61V111.287Z" />
        <path d="M2164.61 139.264H2160.29V169.443H2164.61V139.264Z" />
        <path d="M2162.24 120.475H2162.66V139.263H2162.24V120.475Z" />
        <path d="M2162.24 169.441H2162.66V180.75H2162.24V169.441Z" />
        <path d="M2203.35 113.572H2199.03V139.516H2203.35V113.572Z" />
        <path d="M2200.98 107.389H2201.4V148.077H2200.98V107.389Z" />
        <path d="M2324.93 134.078H2329.25V160.022H2324.93V134.078Z" />
        <path d="M2326.88 127.896H2327.3V168.585H2326.88V127.896Z" />
        <path d="M2353.98 203.887H2358.3V229.83H2353.98V203.887Z" />
        <path d="M2355.93 197.705H2356.35V238.394H2355.93V197.705Z" />
        <path d="M2232.4 58.8555H2228.08V101.267H2232.4V58.8555Z" />
        <path d="M2230.03 48.748H2230.45V115.263H2230.03V48.748Z" />
        <path d="M2315.24 130H2319.56V172.411H2315.24V130Z" />
        <path d="M2317.19 119.893H2317.61V186.408H2317.19V119.893Z" />
        <path d="M2367.98 217.816H2363.66V260.228H2367.98V217.816Z" />
        <path d="M2365.61 207.709H2366.03V274.224H2365.61V207.709Z" />
        <path d="M2251.77 72.0391H2247.45V102.777H2251.77V72.0391Z" />
        <path d="M2249.41 61.9336H2249.83V116.773H2249.41V61.9336Z" />
        <path d="M2377.67 214.139H2373.35V244.876H2377.67V214.139Z" />
        <path d="M2375.3 204.033H2375.72V258.873H2375.3V204.033Z" />
        <path d="M2290.51 123.641H2286.19V135.64H2290.51V123.641Z" />
        <path d="M2288.14 119.695H2288.56V141.104H2288.14V119.695Z" />
        <path d="M2220.35 69.0801H2220.77V120.443H2220.35V69.0801Z" />
        <path d="M2222.72 81.7031H2218.4V126.949H2222.72V81.7031Z" />
        <path d="M2307.5 146.295H2307.92V175.475H2307.5V146.295Z" />
        <path d="M2309.88 158.918H2305.56V181.982H2309.88V158.918Z" />
        <path d="M2336.56 164.336H2336.98V208.397H2336.56V164.336Z" />
        <path d="M2334.61 176.957H2338.93V200.021H2334.61V176.957Z" />
        <path d="M2259.09 79.9785H2259.51V109.159H2259.09V79.9785Z" />
        <path d="M2261.46 92.6016H2257.14V134.799H2261.46V92.6016Z" />
        <path d="M2268.77 111.07H2269.19V140.25H2268.77V111.07Z" />
        <path d="M2271.14 111.02H2266.82V135.823H2271.14V111.02Z" />
        <path d="M2278.45 106.723H2278.87V147.975H2278.45V106.723Z" />
        <path d="M2280.82 114.621H2276.5V139.425H2280.82V114.621Z" />
        <path d="M2384.98 216.293H2385.4V257.545H2384.98V216.293Z" />
        <path d="M2387.36 224.189H2383.04V248.993H2387.36V224.189Z" />
        <path d="M2297.82 132.488H2298.24V173.741H2297.82V132.488Z" />
        <path d="M2300.19 140.385H2295.87V165.188H2300.19V140.385Z" />
        <path d="M2346.25 173.773H2346.67V215.026H2346.25V173.773Z" />
        <path d="M2344.3 181.672H2348.62V206.476H2344.3V181.672Z" />
        <path d="M2239.71 79.9785H2240.14V120.833H2239.71V79.9785Z" />
        <path d="M2242.08 92.6016H2237.77V127.34H2242.08V92.6016Z" />
        <path d="M2394.67 222.568H2395.09V263.424H2394.67V222.568Z" />
        <path d="M2392.72 235.191H2397.04V269.93H2392.72V235.191Z" />
        <path d="M2213.03 85.0918H2208.71V111.479H2213.03V85.0918Z" />
        <path d="M2210.67 59.6797H2211.09V114.992H2210.67V59.6797Z" />
        <path d="M2416.02 204.092H2411.7V272.559H2416.02V204.092Z" />
        <path d="M2413.66 188.854H2414.08V277.926H2413.66V188.854Z" />
        <path d="M2435.39 226.844H2431.07V259.135H2435.39V226.844Z" />
        <path d="M2433.02 213.543H2433.44V260.356H2433.02V213.543Z" />
        <path d="M2425.71 242.305H2421.39V281.873H2425.71V242.305Z" />
        <path d="M2423.34 217.672H2423.76V296.697H2423.34V217.672Z" />
        <path d="M2406.34 261.064H2402.02V291.244H2406.34V261.064Z" />
        <path d="M2403.97 242.275H2404.39V261.064H2403.97V242.275Z" />
        <path d="M2403.97 275.826H2404.39V287.135H2403.97V275.826Z" />
        <path d="M2445.08 220.129H2440.76V246.073H2445.08V220.129Z" />
        <path d="M2442.71 213.947H2443.13V254.636H2442.71V213.947Z" />
        <path d="M2474.13 200.564H2469.81V242.976H2474.13V200.564Z" />
        <path d="M2471.76 190.457H2472.18V256.972H2471.76V190.457Z" />
        <path d="M2462.07 178.074H2462.49V229.437H2462.07V178.074Z" />
        <path d="M2464.44 190.697H2460.12V235.943H2464.44V190.697Z" />
        <path d="M2454.76 194.088H2450.44V220.475H2454.76V194.088Z" />
        <path d="M2452.39 168.674H2452.81V223.986H2452.39V168.674Z" />
    </svg>
</template>
